
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycarsonrentinpune() {



    const cardData =
    {
        keyword: 'Luxury Cars on Rent in Pune',
        heading: 'Platinum24 Cabs: Luxury Cars on Rent in Pune',
        headingDescription: ' Platinum24 Cabs offers premium Luxury Cars on Rent in Pune, perfect for weddings, corporate events, celebrity travel, and special occasions. Our fleet includes high-end sedans and SUVs with plush interiors, modern amenities, and professional chauffeurs to give you a first-class travel experience. Whether it’s an airport pickup, business meeting, or a grand celebration, our luxury car rental service ensures style, comfort, and sophistication. With flexible booking options, transparent pricing, and 24/7 availability, Platinum24 Cabs is the trusted choice for those seeking luxury cars for rent in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it showcases grand gateways, fountains, and gardens. Though partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show recreates Maratha history. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Italian arches and sprawling gardens. It is historically significant as Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. The palace houses a museum displaying Gandhi’s personal items and photographs. Its calm ambiance attracts history and peace seekers. The palace is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon adds mist and waterfalls, enhancing its beauty. Local villagers serve rustic delicacies like pithla-bhakri at the top. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and ornaments, attracting devotees year-round. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable and cultural initiatives. The vibrant spiritual aura makes it a must-visit. Dagdusheth Temple is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. It features rock-cut architecture with massive stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it offers a peaceful retreat from urban life. Evening prayers and chants create a mystical ambiance. Its ancient carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is the highlight for visitors. History lovers and students find it fascinating and educational. The museum preserves centuries of Indian culture and traditions. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. The site also houses smaller shrines and a museum. Sunrise and sunset views are mesmerizing from here. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls add to its charm. Visitors experience rejuvenation and mindfulness here. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy peaceful walks, photography, and picnics here. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a picturesque spot with overflowing streams. Street vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



        "services": [
    {
      "name": "Luxury Car Rental Pune",
      "description": "Choose from a premium selection of luxury car rentals in Pune for weddings, corporate events, VIP transfers, and personal celebrations. Our fleet includes top brands like Mercedes, BMW, Audi, and Jaguar. Enjoy unmatched comfort, stylish interiors, and professional service with each ride."
    },
    {
      "name": "Pune Luxury Car Hire",
      "description": "Hire luxury cars in Pune for any special occasion or executive travel. Whether you need a premium sedan for a business meeting or an SUV for outstation trips, we provide high-end vehicles with flexible rental plans and chauffeur options."
    },
    {
      "name": "Rent Luxury Cars Pune",
      "description": "Rent luxury cars in Pune by the hour, day, or for long-distance travel. Our luxury rentals include advanced features like climate control, leather seats, and entertainment systems for a first-class experience every time you travel."
    },
    {
      "name": "Pune Luxury Taxi Service",
      "description": "Upgrade your travel experience with our luxury taxi services in Pune. Ideal for airport transfers, business commutes, and hotel pickups, our premium taxis are driven by experienced chauffeurs and maintained to the highest standards."
    },
    {
      "name": "Premium Car Rental Pune",
      "description": "Enjoy premium car rental services in Pune with a range of elite vehicles for personal or professional use. Choose from sedans, convertibles, or executive SUVs to match your style and comfort preferences."
    },
    {
      "name": "Luxury Car Booking Pune",
      "description": "Instantly book luxury cars in Pune with just a few clicks. Our platform supports real-time availability, transparent pricing, and a dedicated support team to ensure a smooth and satisfying rental experience."
    },
    {
      "name": "Luxury Sedan Rental Pune",
      "description": "Rent a luxury sedan in Pune like Mercedes C-Class, BMW 5 Series, or Audi A6 for a stylish and smooth ride. Perfect for formal meetings, VIP pickups, or personal celebrations with refined comfort."
    },
    {
      "name": "Pune Luxury SUV Hire",
      "description": "Hire luxury SUVs in Pune including models like Audi Q7, Toyota Fortuner, BMW X5, and more. Ideal for group travel, weddings, and high-end corporate transfers with spacious interiors and high road performance."
    },
    {
      "name": "Affordable Luxury Car Rental Pune",
      "description": "Get the best of luxury without the hefty price tag. We offer affordable luxury car rental options in Pune, complete with competitive rates, flexible packages, and weekend offers for weddings, shoots, and airport runs."
    },
    {
      "name": "Luxury Car Rental with Driver Pune",
      "description": "Book luxury car rentals in Pune with professionally trained, uniformed chauffeurs. Experience door-to-door service, courteous assistance, and premium comfort in every journey — be it a few hours or an entire day."
    },
    {
      "name": "Pune Luxury Car Rental Packages",
      "description": "Explore specially curated luxury car rental packages in Pune for weddings, sightseeing, business travel, and VIP tours. Packages include fuel, driver allowance, and all-inclusive pricing with no hidden charges."
    },
    {
      "name": "Luxury Car Hire for Events Pune",
      "description": "Make a grand entrance at your next event with luxury car hire in Pune. From wedding processions to corporate launches, we provide statement-making vehicles that reflect elegance, prestige, and attention to detail."
    },
    {
      "name": "Luxury Car Service Pune",
      "description": "Get professional luxury car service in Pune for airport transfers, city tours, and corporate meetings. Our focus on cleanliness, punctuality, and premium features ensures a memorable and high-value travel experience."
    },
    {
      "name": "Luxury Car Rental Deals Pune",
      "description": "Find exclusive deals on luxury car rentals in Pune with discounts on weekend bookings, event packages, and multi-day rentals. Book early and save more while enjoying top-tier vehicles and flawless service."
    },
    {
      "name": "Pune Luxury Car Rental for Corporate",
      "description": "Our corporate luxury car rentals in Pune are tailored for executives, business delegations, and VIP clients. Get seamless airport pickups, hourly chauffeur services, and privacy-enhanced rides for critical business needs."
    }
  ],
  "tableData": [
    ["Luxury Car Rental Pune", "Pune Luxury Car Hire"],
    ["Rent Luxury Cars Pune", "Pune Luxury Taxi Service"],
    ["Premium Car Rental Pune", "Luxury Car Booking Pune"],
    ["Luxury Sedan Rental Pune", "Pune Luxury SUV Hire"],
    ["Affordable Luxury Car Rental Pune", "Luxury Car Rental with Driver Pune"],
    ["Pune Luxury Car Rental Packages", "Luxury Car Hire for Events Pune"],
    ["Luxury Car Service Pune", "Luxury Car Rental Deals Pune"],
    ["Pune Luxury Car Rental for Corporate", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Premium Luxury Cars on Rent in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers a wide range of high-end luxury cars for rent in Pune, perfect for weddings, business, and special occasions."
    },
    {
      "WhyChooseheading": "Top Luxury Brands for an Elite Experience",
      "WhyChoosedescription": "Choose from brands like Mercedes, BMW, Audi, and more to make a lasting impression."
    },
    {
      "WhyChooseheading": "Well-Maintained and Chauffeur-Driven Luxury Vehicles",
      "WhyChoosedescription": "All luxury cars are regularly serviced, fully cleaned, and come with trained chauffeurs for a premium ride."
    },
    {
      "WhyChooseheading": "Flexible Rental Packages for Hourly or Full-Day Use",
      "WhyChoosedescription": "Rent a luxury car by the hour, for the day, or for multi-day events as per your convenience."
    },
    {
      "WhyChooseheading": "Ideal for Weddings, Corporate Events & VIP Travel",
      "WhyChoosedescription": "Add elegance and class to your events or business travel with our luxury car rental service."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Get clear, upfront pricing with all-inclusive rates for a worry-free rental experience."
    },
    {
      "WhyChooseheading": "Easy Booking with 24/7 Customer Support",
      "WhyChoosedescription": "Book online or via call anytime. Our support team is always available to help with your requirements."
    },
    {
      "WhyChooseheading": "On-Time Service with Professional Chauffeurs",
      "WhyChoosedescription": "Enjoy punctual service with courteous and experienced chauffeurs ensuring a smooth journey."
    }
  ]







































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer luxury cars on rent in Pune?',
        answer: 'Yes, Platinum24 Cabs provides a premium selection of luxury cars for rent in Pune, perfect for weddings, corporate events, and special occasions.',
    },
    {
        question: 'Which luxury cars are available for rent with Platinum24 Cabs in Pune?',
        answer: 'We offer a fleet of luxury vehicles including Audi, BMW, Mercedes-Benz, Jaguar, and other high-end models.',
    },
    {
        question: 'How can I rent a luxury car in Pune with Platinum24 Cabs?',
        answer: 'You can rent a luxury car by visiting our website, using our mobile app, or calling our customer support for personalized booking assistance.',
    },
    {
        question: 'Are chauffeurs provided with luxury car rentals in Pune?',
        answer: 'Yes, all luxury car rentals include professional, uniformed chauffeurs who are experienced and courteous.',
    },
    {
        question: 'Can I rent a luxury car in Pune for a few hours?',
        answer: 'Absolutely! We offer flexible rental options including hourly, half-day, full-day, and multi-day packages.',
    },
    {
        question: 'Is prior booking required for luxury cars on rent in Pune?',
        answer: 'Yes, we recommend advance booking to ensure vehicle availability and to meet any special requirements you may have.',
    },
    {
        question: 'Are the luxury cars well-maintained and sanitized?',
        answer: 'All our luxury vehicles are meticulously maintained, regularly serviced, and sanitized to ensure top-notch hygiene and safety.',
    },
    {
        question: 'Can I book a luxury car for outstation travel from Pune?',
        answer: 'Yes, we provide luxury cars for outstation trips as well, with customized packages and premium services.',
    },
    {
        question: 'What occasions are suitable for booking luxury cars in Pune?',
        answer: 'Our luxury cars are ideal for weddings, VIP airport transfers, corporate travel, film shoots, and romantic date nights.',
    },
    {
        question: 'Do you offer customized packages for luxury car rentals in Pune?',
        answer: 'Yes, we provide tailor-made packages based on your event type, duration, and travel preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Aditya Mehra',
        feedback: 'Booked a Mercedes for my wedding through Platinum24 Cabs. The car was spotless and the chauffeur was extremely professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rhea Sharma',
        feedback: 'Excellent experience renting a BMW for a corporate event. Hassle-free booking and first-class service!',
        rating: 5,
    },
];

















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const luxuryCarsPuneSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Luxury Cars on Rent in Pune offering premium car rental services including luxury sedans, SUVs, and chauffeur-driven cars for events and corporate needs.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "Luxury Car Rental Pune",
    "Pune Luxury Car Hire",
    "Rent Luxury Cars Pune",
    "Pune Luxury Taxi Service",
    "Premium Car Rental Pune",
    "Luxury Car Booking Pune",
    "Luxury Sedan Rental Pune",
    "Pune Luxury SUV Hire",
    "Affordable Luxury Car Rental Pune",
    "Luxury Car Rental with Driver Pune",
    "Pune Luxury Car Rental Packages",
    "Luxury Car Hire for Events Pune",
    "Luxury Car Service Pune",
    "Luxury Car Rental Deals Pune",
    "Pune Luxury Car Rental for Corporate"
  ]
};








    return (
        <div>

<Helmet>
  <title>Luxury Cars on Rent in Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Luxury Cars on Rent in Pune offering premium car rental services including luxury sedans, SUVs, and chauffeur-driven cars for events and corporate needs."
  />
  <meta
    name="keywords"
    content="Luxury Car Rental Pune, Pune Luxury Car Hire, Rent Luxury Cars Pune, Pune Luxury Taxi Service, Premium Car Rental Pune, Luxury Car Booking Pune, Luxury Sedan Rental Pune, Pune Luxury SUV Hire, Affordable Luxury Car Rental Pune, Luxury Car Rental with Driver Pune, Pune Luxury Car Rental Packages, Luxury Car Hire for Events Pune, Luxury Car Service Pune, Luxury Car Rental Deals Pune, Pune Luxury Car Rental for Corporate"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryCarsPuneSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/94.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxurycarsonrentinpune;